
import React from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { Outlet } from 'react-router-dom';

import { ModuleDeclaration } from '../ModuleDeclaration';

import DocumentList from './DocumentList/DocumentList';
import EditDocument from './EditDocument/EditDocument';
import ViewDocument from './ViewDocument/ViewDocument';

const DocumentsContainer = (props: any): JSX.Element => {
  const element = withAuthenticationRequired(Outlet)(props);
  return element!;
};

const DocumentRouteProperties: ModuleDeclaration = {
  routeProps: {
    path: '/documents',
    element: <DocumentsContainer />,
    children: [
      { index: true, element: <DocumentList /> },
      { path: '/documents/view/:id', element: <ViewDocument /> },
      { path: '/documents/edit/:id', element: <EditDocument /> },
    ],
  },
  name: 'Articles',
  isHidden: false,
  containerCss: 'p-5 mb-5 border-bottom container-fluid',
  iconClassName: 'bi bi-journal-richtext',
};

export default DocumentRouteProperties;
